import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import { StockContext } from "../../Context/StockContext";
import styles from "./StockAdjustment.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toCommas } from "../../utils/utils";
import { useSnackbar } from "react-simple-snackbar";
import AddSupplier from "../../components/Suppliers/AddSupplier";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { initialStateStockAdjustment } from "../../initialStateStockAdjustment";
import currencies from "../../currencies.json";
import {
  createStockAdjustment,
  getStockAdjustment,
  updateStockAdjustment,
} from "../../actions/stockAdjustmentActions";
// import { updateItems } from "../../actions/itemActions";
import { createStock, deleteStockById } from "../../actions/stockActions";
import SignaturePad from "./SignaturePad";
import { getClientsByUser, getAllClients } from "../../actions/clientActions";
import { getAllSuppliers } from "../../actions/supplierActions";
// import {getItems } from '../../actions/itemActions'
import AddClient from "./AddClient";
import StockAdjustmentType from "./StockAdjustmentType";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { getItemsByUser, getAllItems } from "../../actions/itemActions";
import { endOfDay } from "date-fns";
// import AddItem from '../Items/addItem'

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
    padding: theme.spacing(3),
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
}));
const options = {
  position: "bottom",
  style: {
    backgroundColor: "red",
    border: "2px solid red",
    color: "white",
    fontFamily: "Menlo, monospace",
    fontSize: "20px",
    textAlign: "center",
  },
  closeStyle: {
    color: "lightcoral",
    fontSize: "16px",
  },
};
const StockAdjustment = () => {
  const location = useLocation();
  const [stockAdjustmentData, setStockAdjustmentData] = useState(
    initialStateStockAdjustment
  );
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState(currencies[1].value);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  console.log("SA total", total);
  const [error, setError] = useState("");
  const [client, setClient] = useState(null);
  const [defaultClient, setDefaultClient] = useState(null);
  const [editQty, setEditQty] = useState(false);
  const inputRef = useRef(null);
  // const [signatureDataUrl, setSignatureDataUrl] = useState(null)
  //console.log(client);
  const [timer, setTimer] = useState(null);
  // (supplier);
  const { getCurrentStockQty } = useContext(StockContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar(options);
  // const [item, setItem] = useState(null);
  const [type, setType] = useState("StockAdjustment");
  const [status, setStatus] = useState("");
  const { id } = useParams();
  // const [scanning, setScanning] = useState(false);
  const clients = useSelector((state) => state.clients.clients);
  const suppliers = useSelector((state) => state.suppliers.suppliers);

  const [supplier, setSupplier] = useState(null);
  console.log("Supplier", supplier);
  const items = useSelector((state) => state.items.items);
  console.log(items);
  const { stockAdjustment } = useSelector((state) => state.stockAdjustments);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const today = new Date();

  const [selectedDate, setSelectedDate] = useState(
    today.getTime() + 7 * 24 * 60 * 60 * 1000
  );
  useEffect(() => {
    getTotalCount();
    // eslint-disable-next-line
  }, []);

  const getTotalCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/stockAdjustments/count?searchQuery=${user?.result?._id}`
      );
      const currentDate = new Date();
      // console.log("Date: ", currentDate);
      const stockAdjustmentCount = response.data;
      const sequentialstockAdjustmentNumber = stockAdjustmentCount + 1;

      // const year = currentDate.getFullYear();
      // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      // const day = String(currentDate.getDate()).padStart(2, "0");
      // const hours = String(currentDate.getHours()).padStart(2, "0");
      // const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      // const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      // const randomID = Math.floor(100 + Math.random() * 900);
      // const stockAdjustmentNumber = `${randomID}${seconds}`;
      // const stockAdjustmentNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

      // console.log("CurrentDate", currentDate);

      //   console.log(response.data);
      //Get total count of stockAdjustment from the server and increment by one to serialized numbering of stockAdjustment
      setStockAdjustmentData({
        ...stockAdjustmentData,
        // stockAdjustmentNumber: stockAdjustmentNumber,
        stockAdjustmentNumber: sequentialstockAdjustmentNumber.toString(), // "1", "2", "3", etc.
      });
    } catch (error) {
      console.error(error);
    }
  };
  // Listen for changes in the form data
  useEffect(() => {
    // Whenever formData changes, set hasUnsavedChanges to true
    setHasUnsavedChanges(true);
  }, [stockAdjustmentData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        // Display a confirmation message
        e.preventDefault();
        e.returnValue = " Are you sure you want to leave this page?";
      }
    };

    // Attach the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
  useEffect(() => {
    dispatch(getStockAdjustment(id));

    // eslint-disable-next-line
  }, [id]);
  useEffect(() => {
    const defaultClient = clients.filter((clt) => clt.name === "Cash");
    console.log("Default Client", defaultClient);
    setDefaultClient(defaultClient[0]);
  }, [clients]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllSuppliers()
    );

    dispatch(
      // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    if (!stockAdjustment) {
      setClient(null);
      setSupplier(null);
    }
  }, [location]);
  // useEffect(() => {
  //   if (stockAdjustment) {
  //     //Automatically set the default stockAdjustment values as the ones in the stockAdjustment to be updated
  //     setStockAdjustmentData(stockAdjustment);
  //     setRates(stockAdjustment.rates);
  //     setClient(stockAdjustment.client);
  //     setSupplier(stockAdjustment.supplier);
  //     setType(stockAdjustment.type);
  //     setStatus(stockAdjustment.status);
  //     setSelectedDate(stockAdjustment.dueDate);
  //     // setSignatureDataUrl(stockAdjustment.signatureDataUrl);
  //   }
  // }, [stockAdjustment]);

  useEffect(() => {
    if (stockAdjustment) {
      // Set initial stockAdjustment data
      setStockAdjustmentData(stockAdjustment);
      setRates(stockAdjustment.rates);
      setClient(stockAdjustment.client);
      setSupplier(stockAdjustment.supplier);
      setType(stockAdjustment.type);
      setStatus(stockAdjustment.status);
      setSelectedDate(stockAdjustment.dueDate);

      // Fetch currentStock for each item
      const fetchStockForItems = async () => {
        const updatedItems = await Promise.all(
          stockAdjustment.items.map(async (item) => {
            const stock = await getAvailableStock(item.item._id);
            return {
              ...item,
              currentStock: stock ? stock : 0, // Ensure a fallback value
            };
          })
        );
        setStockAdjustmentData((prev) => ({ ...prev, items: updatedItems }));
      };

      fetchStockForItems().catch((error) =>
        console.error("Error fetching stock:", error)
      );
    }
  }, [stockAdjustment]);

  useEffect(() => {
    if (type === "Receipt") {
      setStatus("Paid");
    } else {
      setStatus("Unpaid");
    }
  }, [type]);

  const defaultProps = {
    options: currencies,
    getOptionLabel: (option) => option.label,
  };

  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  const suppliersProps = {
    options: suppliers,
    getOptionLabel: (option) => option.name || "",
  };
  const itemsProps = {
    options: items,
    getOptionLabel: (option) => option.itemName || "",
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleRates = (e) => {
    setRates(e.target.value);
    setStockAdjustmentData((prevState) => ({
      ...prevState,
      tax: e.target.value,
    }));
  };

  // Add this useEffect:
  useEffect(() => {
    const calculateTotal = () => {
      const totalPrice = stockAdjustmentData.items.reduce((sum, item) => {
        const quantity = parseFloat(item.quantity) || 0;
        const unitPrice = parseFloat(item.item?.unitPrice) || 0;
        return sum + quantity * unitPrice;
      }, 0);
      setTotal(totalPrice);
      if (stockAdjustmentData.items.length === 0) {
        setTotal(0);
      }
    };
    calculateTotal();
  }, [stockAdjustmentData]);

  // console.log(stockAdjustmentData)
  // Change handler for dynamically added input field
  // const handleChange = (index, e) => {
  //   const values = [...stockAdjustmentData.items];
  //   const { name, value } = e.target;
  //   values[index][name] = name === "quantity" || name === "unitPrice" ? parseFloat(value) || 0 : value;
  //   console.log("Updated values:", values);
  //   setStockAdjustmentData((prev) => ({ ...prev, items: values }));
  // };

  const handleChange = (index, e) => {
    const values = [...stockAdjustmentData.items];
    values[index][e.target.name] = e.target.value;
    setStockAdjustmentData({ ...stockAdjustmentData, items: values });
  };

  const getAvailableStock = async (itemId) => {
    const data = await getCurrentStockQty(itemId);
    console.log(data);
    // ;
    const currentStock = data.currentStock?.$numberDecimal || data.currentStock;
    return currentStock;
  };
  // const handleNameChange = (index, e, value) => {
  //   console.log(value)
  //   const values = [...stockAdjustmentData.items];
  //   values[index].itemName = value;
  //   values[index].unitPrice = getItemPrice(value);
  //   setStockAdjustmentData({ ...stockAdjustmentData, items: values });

  // };
  // const getItemPrice = (itemName) => {
  //   // console.log('getItemPrice function in', itemName);
  //   // console.log("itemName: " + itemName)

  //   const selectedItem = items.find((item) => item.itemName === itemName.itemName);
  //   // console.log("selected item: " + selectedItem)
  //   return selectedItem ? selectedItem.unitPrice : 0; // Return 0 if item price is not found
  // };
  const handleNameChange = async (index, value) => {
    const updatedItems = [...stockAdjustmentData.items];

    try {
      const stock = await getAvailableStock(value._id); // Wait for the stock data

      updatedItems[index] = {
        ...updatedItems[index],
        item: value,
        currentStock: stock, // Use the resolved stock value
      };

      setStockAdjustmentData({ ...stockAdjustmentData, items: updatedItems }); // Update state
      console.log("Items", updatedItems); // Use updatedItems to log correctly
      setEditQty(true);
    } catch (error) {
      console.error("Error fetching stock:", error);
    }
  };
  const displayItems = () => {
    console.log("Updated Item ", stockAdjustmentData.items);
    // dispatch(updateItems(updatedCartItems,openSnackbar))
  };
  let barcodeScan = "";
  useEffect(() => {
    function handleKeyDown(e) {
      // console.log("handle")
      if (e.keyCode === 13 && barcodeScan.length > 3) {
        console.log("Barcode Scan: " + barcodeScan);
        handleBarcodeScan(barcodeScan);
        return;
      }
      if (e.keyCode === 16) {
        return;
      }
      barcodeScan += e.key;
      setTimeout(() => {
        barcodeScan = "";
        console.log("Barcode Scan: " + barcodeScan);
      }, 100);
    }
    document.addEventListener("keydown", handleKeyDown);
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleBarcodeScan = async (scannedValue) => {
    console.log("handleBarcodeScan Called");
    const scannedItem = scannedValue;
    // Find the item with a matching barcode
    const matchingItem = items.find(
      (item) => item.barcode === scannedItem || item._id === scannedItem
    );
    console.log("Matching", matchingItem);

    if (matchingItem) {
      try {
        // Get the current stock for this item
        const currentStock = await getAvailableStock(matchingItem._id);

        // Check if the item already exists in the stockAdjustmentData
        const existingItemIndex = stockAdjustmentData.items.findIndex(
          (item) => item.item?._id === matchingItem._id
        );

        if (existingItemIndex !== -1) {
          // If the item already exists, just increment the quantity
          const updatedItems = [...stockAdjustmentData.items];
          updatedItems[existingItemIndex].quantity =
            parseInt(updatedItems[existingItemIndex].quantity || 0, 10) + 1;

          setStockAdjustmentData({
            ...stockAdjustmentData,
            items: updatedItems,
          });
        } else {
          // If it's a new item, add it with full details and quantity of 1
          const newItem = {
            item: matchingItem, // Store the full item object
            quantity: 1,
            currentStock: currentStock, // Add current stock info
          };

          const updatedItems = [...stockAdjustmentData.items, newItem];
          setStockAdjustmentData({
            ...stockAdjustmentData,
            items: updatedItems,
          });
        }
      } catch (error) {
        console.error("Error fetching stock:", error);
        openSnackbar("Error fetching stock information");
      }
    } else {
      openSnackbar(
        searchQuery
          ? "Item not found for the entered barcode. Please check."
          : "Item not found for the scanned barcode. Please check."
      );
    }
  };

  // const handleBarcodeScan = (scannedValue) => {
  //   console.log("handleBarcodeScan Called");
  //   const scannedItem = scannedValue;
  //   // Find the item with a matching barcode
  //   const matchingItem = items.find(
  //     (item) => item.barcode === scannedItem || item._id === scannedItem
  //   );

  //   if (matchingItem) {
  //     // Check if the item already exists in the stockAdjustmentData
  //     const existingItemIndex = stockAdjustmentData.items.findIndex(
  //       (item) => item.itemName === matchingItem.itemName
  //     );

  //     if (existingItemIndex !== -1) {
  //       // If the item already exists, update the quantity by one
  //       const updatedItems = [...stockAdjustmentData.items];
  //       updatedItems[existingItemIndex].quantity =
  //         parseInt(updatedItems[existingItemIndex].quantity, 10) + 1;

  //       setStockAdjustmentData({ ...stockAdjustmentData, items: updatedItems });
  //     } else {
  //       // If it's a new item, add it with a quantity of 1
  //       const updatedItems = [...stockAdjustmentData.items];
  //       updatedItems.push({
  //         itemName: matchingItem.itemName,
  //         unitPrice: matchingItem.unitPrice,
  //         unit: matchingItem.unit,
  //         quantity: 1,
  //       });

  //       setStockAdjustmentData({ ...stockAdjustmentData, items: updatedItems });
  //     }
  //   } else {
  //     {
  //       searchQuery
  //         ? openSnackbar(
  //             "Item not found for the entered barcode. Please check."
  //           )
  //         : openSnackbar(
  //             "Item not found for the scanned barcode. Please check."
  //           );
  //     }
  //   }
  // };

  const handleBarcodeInputChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    handleBarcodeScan(searchQuery);
    // setSearchQuery("");
  };

  useEffect(() => {
    //Get the subtotal
    const subTotal = () => {
      var arr = document.getElementsByName("amount");
      var subtotal = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          subtotal += +arr[i].value;
        }
        // document.getElementById("subtotal").value = subtotal;
        setSubTotal(subtotal);
      }
    };

    subTotal();
  }, [stockAdjustmentData]);

  useEffect(() => {
    const total = () => {
      //Tax rate is calculated as (input / 100 ) * subtotal + subtotal
      const overallSum = subTotal - (rates / 100) * subTotal;
      //VAT is calculated as tax rates /100 * subtotal
      setVat((rates / 100) * subTotal);
      setTotal(overallSum);
      if (stockAdjustmentData.items.length === 0) {
        setTotal(0);
      }
    };
    total();
  }, [stockAdjustmentData, rates, subTotal]);

  const handleAddField = (e) => {
    e.preventDefault();
    setStockAdjustmentData((prevState) => ({
      ...prevState,
      items: [...prevState.items, { item: {}, quantity: 0,cost: 0, currentStock: "" }],
    }));
  };

  const handleRemoveField = (index) => {
    const values = stockAdjustmentData.items;
    values.splice(index, 1);
    setStockAdjustmentData((prevState) => ({ ...prevState, values }));
    // console.log(values)
  };
  const handleClient = (value) => {
    setSelectedDate(today.getTime() + value?.dueDate * 24 * 60 * 60 * 1000);
  };
  // console.log(stockAdjustmentData);
  const stockDetailsItems = async (cartItems, stockAdjustmentNumber) => {
    const stockItems = await Promise.all(
      cartItems.map(async (item) => ({
        item: item.item._id,
        transactionType: "STOCK_ADJUSTMENT",
        qty:
          stockAdjustmentData.adjustType === "Add"
            ? item.quantity
            : -1 * item.quantity,
        categoryId: item.item?.category?.categoryId,
        stockAdjustmentId: stockAdjustmentNumber,
        createdAt: new Date(),
        unit: item.item?.units.stock.unit,
        references: {
          stockAdjustmentId: stockAdjustmentNumber,
          transactionRef: `${
            stockAdjustmentData.adjustType === "Add"
              ? "Stock Adjustment Addition"
              : "Stock Adjustment Deduction"
          }`,
        },
        creator: user?.result?._id || "65549a5b77d1c64130b5db0c",
      }))
    );
    ;
    return stockItems;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasEmptyItems = stockAdjustmentData.items.some(
      (item) => !item.quantity && !item.adjustType && !item.cost
    );
    if (
      hasEmptyItems
      // !subTotal ||
      // !total
      // !vat ||
      // !rates ||
      //  !currency ||
      // !selectedDate ||
      // !client
      // !signatureDataUrl||
      // !supplier
      // !type ||
      // !status
    ) {
      // console.log("client", client);
      // Update the error state with an appropriate error message
      openSnackbar("Please fill the details");
      return;
    }
    // const currentDate = new Date();
    // const year = currentDate.getFullYear();
    // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    // const day = String(currentDate.getDate()).padStart(2, "0");
    // const hours = String(currentDate.getHours()).padStart(2, "0");
    // const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    // const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    // const randomID = Math.floor(100 + Math.random() * 900);
    //    const stockAdjustmentNumber = `${randomID}${seconds}`;

    // const stockAdjustmentNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

    setError("");
    const formattedItems = stockAdjustmentData.items.map((item) => ({
      item: item.item._id,
      quantity: parseFloat(item.quantity),
      cost: parseFloat(item.cost)
    }));
    if (stockAdjustment) {
      dispatch(
        updateStockAdjustment(stockAdjustment._id, {
          ...stockAdjustmentData,
          subTotal: subTotal,
          items: formattedItems,
          total: total,
          vat: vat,
          rates: rates,
          currency: currency,
          dueDate: selectedDate,
          type: type,
          status: status,
          isPrintBill: true,
        })
      );

      // Pass the stockAdjustmentNumber and type, with openSnackbar
      dispatch(
        deleteStockById(
          stockAdjustmentData.stockAdjustmentNumber,
          "STOCK_ADJUSTMENT"
        )
      )
        .then(() => {
          console.log("Deletion successful");
          history.push(`/stockAdjustment/${stockAdjustment._id}`);
        })
        .catch((err) => console.error("Deletion failed:", err));

      console.log(
        stockAdjustmentData.stockAdjustmentNumber,
        "STOCK_ADJUSTMENT"
      );

      dispatch(
        createStockAdjustment(
          {
            ...stockAdjustmentData,
            subTotal: subTotal,
          items: formattedItems,

            total: total,
            vat: vat,
            rates: rates,
            currency: currency,
            dueDate: selectedDate,
            stockAdjustmentNumber: stockAdjustmentData.stockAdjustmentNumber,

            // signatureDataUrl,
            type: type,
            status: status,
            paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            createdAt: new Date(),
            isPrintBill: true,
          },
          history
        )
      );
      console.log(
        "stockDetailsItems",
        stockDetailsItems(
          stockAdjustmentData.items,
          stockAdjustmentData.stockAdjustmentNumber
        )
      );
      const stockTransactions = await stockDetailsItems(
        stockAdjustmentData.items,
        stockAdjustmentData.stockAdjustmentNumber
      );
      dispatch(createStock(stockTransactions));

      // history.push(`/stockAdjustment/${stockAdjustment._id}`);
    } else {
      dispatch(
        createStockAdjustment(
          {
            ...stockAdjustmentData,
            subTotal: subTotal,
            total: total,
          items: formattedItems,

            vat: vat,
            rates: rates,
            currency: currency,
            dueDate: selectedDate,
            stockAdjustmentNumber: stockAdjustmentData.stockAdjustmentNumber,

            // signatureDataUrl,
            type: type,
            status: status,
            paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            createdAt: new Date(),
            isPrintBill: true,
          },
          history
        )
      );
      console.log(
        "stockDetailsItems",
        stockDetailsItems(
          stockAdjustmentData.items,
          stockAdjustmentData.stockAdjustmentNumber
        )
      );
      const stockTransactions = await stockDetailsItems(
        stockAdjustmentData.items,
        stockAdjustmentData.stockAdjustmentNumber
      );
      dispatch(createStock(stockTransactions));
    }

    setStockAdjustmentData(initialStateStockAdjustment);
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // const [openSupplier, setOpenSupplier] = useState(false);
  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }
  const filteredItems = useMemo(() => {
    return items.filter((item) => item.toggleStock === true && item.isActive);
  }, [items]);
  const isDeduct = stockAdjustmentData.adjustType === "Deduct";
  return (
    <div className={styles.stockAdjustmentLayout}>
      <form onSubmit={handleSubmit} className="mu-form">
        <AddClient setOpen={setOpen} open={open} />
        {/* <AddSupplier setOpen={setOpenSupplier} open={openSupplier} /> */}
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="center">
            <Grid item>
              <StockAdjustmentType type={type} setType={setType} />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                  ID:
                </span> */}
                <div
                  style={{
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <p>
                    {stockAdjustment
                      ? moment(stockAdjustment.createdAt).format(" Do MMM YYYY")
                      : moment().format("Do MMM YYYY")}
                  </p>
                </div>
                <div>{stockAdjustmentData.stockAdjustmentNumber}</div>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Grid
          container
          justifyContent="space-between"
          style={{ marginTop: "40px", marginBottom: "20px" }}
        >
          <Grid item xs={12} md={6} style={{ paddingRight: "10px" }}>
            <Container>
              <div>
                <FormControl component="fieldset">
                  <FormLabel component="legend" style={{ color: "black" }}>
                    Adjust Type
                  </FormLabel>

                  <RadioGroup
                    aria-label="adjust-type"
                    name="adjust-type"
                    value={stockAdjustmentData.adjustType}
                    onChange={(e) => {
                      setStockAdjustmentData({
                        ...stockAdjustmentData,
                        adjustType: e.target.value,
                      });
                    }}
                    row
                  >
                    <FormControlLabel
                      value="Add"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Add"
                    />
                    <FormControlLabel
                      value="Deduct"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Deduct"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Container>
          </Grid>
          <Grid>
            <div>
              <Container
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "start",
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                <TextField
                  id="search-bar"
                  label="Enter Barcode"
                  variant="outlined"
                  margin="normal"
                  value={searchQuery}
                  onChange={handleBarcodeInputChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      // Execute your function here with e.target.value
                      e.preventDefault();
                    }
                  }}
                />
                {searchQuery && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleSearchSubmit}
                    style={{ margin: "0 0 20px 20px" }}
                  >
                    Add Item
                  </Button>
                )}
              </Container>
            </div>
          </Grid>
        </Grid>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "20px" }}>Delete</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Item</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Sales Unit</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>
                    Purchase Unit
                  </TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Stock Unit</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>
                    Available Stock
                  </TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Qty</TableCell>

                  {!isDeduct && (
      <>
        <TableCell style={{ fontSize: "20px" }}>Price</TableCell>
        <TableCell style={{ fontSize: "20px" }}>Amount</TableCell>
      </>
    )}
                
                  {/* Add */}
                </TableRow>
              </TableHead>

              {/* <TableBody>
                {stockAdjustmentData.items.map((itemField, index) => (
                
                  <TableRow key={index}>
                    <TableCell align="left">
                      <IconButton
                        style={{ border: "1px solid red" }}
                        onClick={() => handleRemoveField(index)}
                      >
                        <DeleteOutlineRoundedIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "red",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {stockAdjustmentData.items[index].itemName}
                      <div
                        style={
                          stockAdjustmentData.items[index].itemName
                            ? { display: "none" }
                            : { display: "block" }
                        }
                      >
                        <FormControl variant="outlined" fullWidth>
                          <Autocomplete
                            options={filteredItems}
                            getOptionLabel={(item) => item.itemName}
                            value={itemField?.item?.itemName}
                            onChange={(e, value) => {
                              handleNameChange(index, value || "");
                              inputRef.current.focus();
                            }} 
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Search Item"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </div>
                    </TableCell>

                   

                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item.itemName ? (
                        <span>
                          {itemField.item.units?.sale?.unit?.name}
                        </span>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item.itemName ? (
                        <span>
                          {itemField.item.units?.purchase?.unit?.name}
                        </span>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item.itemName ? (
                        <span>
                          {itemField.item.units?.stock?.unit?.name}
                        </span>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item?.itemName
                        ? `${itemField.currentStock} ${itemField.item?.units?.stock?.unit?.abbreviation}`
                        : 0}
                    </TableCell>
                    <TableCell align="left" style={{ fontSize: "18px" }}>
                      <InputBase
                        inputRef={inputRef}
                        sx={{ ml: 1, flex: 1, width: "10px" }}
                        type="number"
                        name="quantity"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.quantity ?? ""}
                        placeholder="0"
                        style={{ fontSize: "18px", width: "60px" }}
                      />
                    </TableCell>

                 
                  </TableRow>
                ))}
              </TableBody> */}
              <TableBody>
                {stockAdjustmentData.items.map((itemField, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">
                      <IconButton
                        style={{ border: "1px solid red" }}
                        onClick={() => handleRemoveField(index)}
                      >
                        <DeleteOutlineRoundedIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "red",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {/* If editing (stockAdjustment exists) and item is pre-filled, show name only */}
                      {stockAdjustment && itemField.item?.itemName ? (
                        <Typography variant="body1">
                          {itemField.item.itemName}
                        </Typography>
                      ) : (
                        /* If creating or adding a new item, show Autocomplete */
                        <FormControl variant="outlined" fullWidth>
                          <Autocomplete
                            options={filteredItems}
                            getOptionLabel={(item) => item.itemName || ""}
                            value={
                              itemField.item &&
                              Object.keys(itemField.item).length > 0
                                ? itemField.item
                                : null
                            }
                            onChange={(e, value) => {
                              handleNameChange(index, value || "");
                              inputRef.current.focus();
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Search Item"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item?.itemName
                        ? itemField.item.units?.sale?.unit?.name || ""
                        : ""}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item?.itemName
                        ? itemField.item.units?.purchase?.unit?.name || ""
                        : ""}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item?.itemName
                        ? itemField.item.units?.stock?.unit?.name || ""
                        : ""}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ cursor: "context-menu", fontSize: "18px" }}
                    >
                      {itemField.item?.itemName &&
                      itemField.currentStock !== undefined
                        ? `${itemField.currentStock.toFixed(2)} ${
                            itemField.item?.units?.stock?.unit?.abbreviation ||
                            ""
                          }`
                        : "0"}
                    </TableCell>
                    <TableCell align="left" style={{ fontSize: "18px" }}>
                        <InputBase
                          inputRef={inputRef}
                          sx={{ ml: 1, flex: 1, width: "10px" }}
                          type="number"
                          name="quantity"
                          onChange={(e) => handleChange(index, e)}
                          value={itemField?.quantity || "0"}
                          placeholder="0"
                          style={{ fontSize: "18px", width: "60px" }}
                        />
                      </TableCell>
                      {!isDeduct && (
        <>
          <TableCell
            align="left"
            style={{ cursor: "context-menu", fontSize: "18px" }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1, width: "10px" }}
              type="number"
              name="cost"
              onChange={(e) => handleChange(index, e)}
              value={itemField?.cost || "0"}
              placeholder="0"
              style={{ fontSize: "18px", width: "60px" }}
            />
          </TableCell>
          <TableCell align="center">
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              type="number"
              name="amount"
              onChange={(e) => handleChange(index, e)}
              value={itemField?.quantity * itemField?.cost || 0}
              disabled
              style={{ fontSize: "18px", display: "none" }}
            />
            <Typography variant="h5" color="initial">
              {itemField?.quantity * itemField?.cost || 0}
            </Typography>
          </TableCell>
        </>
      )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button
              onClick={handleAddField}
              style={{ backgroundColor: "#ef7f1a", color: "white" }}
              // disabled={scanning}
            >
              +
            </button>
          </div>
        </div>
        {/* <div>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingRight: "10px", marginTop: "10px" }}
          >
            <Container></Container>
          </Grid> */}
        <div className={styles.stockAdjustmentSummary}>
          <div className={styles.summary}>Order Summary</div>
          <div className={styles.summaryItem}>
            <p>Total Items:</p>
            <h4>
              {stockAdjustmentData.items.reduce((accumulator, item) => {
                const quantity = parseInt(item.quantity, 10) || 0;
                return accumulator + quantity;
              }, 0)}
            </h4>
          </div>
          {stockAdjustmentData.adjustType && (
            <div className={styles.summaryItem}>
              <p>Adjust Type:</p>
              <h4>{stockAdjustmentData.adjustType}</h4>
            </div>
          )}
         {!isDeduct && (
    <div className={styles.summaryItem}>
      <p>Total Price:</p>
      <h4>
        {currency} {toCommas(total.toFixed(2))}
      </h4>
    </div>
  )}
        </div>
        {/* </div> */}
        {/* <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginTop: "16px", marginRight: 40 }}>
                <TextField
                  type="text"
                  step="any"
                  name="rates"
                  id="rates"
                  value={rates}
                  onChange={handleRates}
                  placeholder="e.g 10"
                  label="Discount(%)"
                />
              </Grid> */}
        {/* <Grid item style={{ marginRight: 10, marginLeft: 80 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid> */}
        {/* <Grid item style={{ width: 270, marginRight: 10 }}>
                <Autocomplete
                  {...defaultProps}
                  id="debug"
                  debug
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select currency"
                      margin="normal"
                    />
                  )}
                  value={currency.value}
                  onChange={(event, value) => setCurrency(value.value)}
                />
              </Grid> */}
        {/* </Grid>
          </Container>
        </div> */}
        <br />
        {/* {signatureDataUrl ? (
               <div>
            
              <img src={signatureDataUrl} alt="signature" className="signature" width={150} height={150}/>
             
              
              <Button
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "none",
                      backgroundColor: "#ef7f1a",
                      color: "white",
                      margin:5
                    }}
                    onClick={() => setSignatureDataUrl(null)}
                  >
                    Change
                  </Button>
                  </div>
            ):<div>
           
            <SignaturePad setSignatureDataUrl={setSignatureDataUrl}/>{
             
            }
          </div>} */}

        <div className={styles.note}>
          <h4>Notes/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) => {
              // console.log("StockAdjustment.js me  signature console.log",signatureDataUrl)
              setStockAdjustmentData({
                ...stockAdjustmentData,
                notes: e.target.value,
              });
            }}
            value={stockAdjustmentData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            style={{
              justifyContentContent: "center",
              backgroundColor: "#ef7f1a",
              color: "white",
            }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
          {error && (
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: "10px" }}
            >
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </div>
  );
};

export default StockAdjustment;
